<!-- 
Expander panel showing the debt to equity calculation.
-->
<template>
  <div>
    <a
      :id="'focus-' + panelNumber"
      href="#" class="section-heading subheading d-block pl-4 pr-5 pt-3 pb-3"
      @click.stop.prevent="$emit('click:togglePanel', panelDebtToEquityScore)"
    >
      <v-icon class="financial-strength-breakdown">subdirectory_arrow_right</v-icon>
      Financial strength: Debt to equity score
      <v-btn icon class="focus-button" tabindex="-1">
        <v-icon :class="'expand-icon ' + (expanded ? 'expanded' : '')">expand_more</v-icon>
      </v-btn>
    </a>
    <v-expand-transition>
      <v-card v-show="expanded" flat>
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
        <div v-if="!isInternal" class="caption pl-4 pr-4 pt-2" v-html="templates.DebtToEquityScore"/>
        <v-card-text class="pt-2 px-0 pb-0">
          <v-layout row wrap mx-4>
            <v-flex 
              xs12 sm4 mt-2 pt-1 
              class="text-xs-right"
            >
              <our-data-field label="Debt to equity formula" label-width="11">
                Total liabilities / Total equity
              </our-data-field>
              <our-data-field v-if="notApplicable" label="Debt to equity" label-width="11">
                Total equity &leq; 0
                <br>
                (minimum score applies)
              </our-data-field>
              <our-data-field v-else label="Debt to equity" label-width="11">
                {{ levyParameters.totalLiabilities | currency }} / {{ levyParameters.totalEquity | currency }}
                =
                <precise-risk-factor-number 
                  :value="levyCalculation.debtToEquity"
                  :decimal-places="2"
                  :levy-collection-id="levyCollection.id" 
                  :estimator-key="estimatorKey" 
                  type="DebtToEquity"
                />
              </our-data-field>
            </v-flex>
            <v-flex xs12 sm4 pb-4>
              <risk-factor-table
                :estimator-key="estimatorKey" 
                :levy-collection-id="levyCollection.id" 
                :selected-score="levyCalculation.debtToEquityScore" 
                is-percentage 
                type="DebtToEquity" 
                title="Debt to equity"
                terminology="Score"
              />
            </v-flex>
            <v-flex 
              xs12 sm4 mt-2 pt-1 
              class="text-xs-right"
            >
              <our-data-field label="Debt to equity score" typography="title" label-width="11">
                {{ levyCalculation.debtToEquityScore | numericInput2 }}
                <template v-slot:footer>
                  <playground-up-down v-if="isLevyEstimator" field="debtToEquityScore" show-original small/>
                </template>
              </our-data-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import mixins from "./mixins";
import PlaygroundUpDown from "@/components/levy-collection-providers/calculation/PlaygroundUpDown.vue";
import RiskFactorTable from "@/components/levy-collection-providers/calculation/RiskFactorTable.vue";
import PreciseRiskFactorNumber from "@/components/levy-collection-providers/calculation/PreciseRiskFactorNumber.vue";

export default {
  components: {
    PlaygroundUpDown,
    RiskFactorTable,
    PreciseRiskFactorNumber
  },
  mixins: [filterMixins, mixins],
  props: {
    expanded: {
      type: Boolean,
      required: true
    },
    panelNumber: {
      type: Number,
      required: true
    }
  },
  computed: {
    notApplicable() {
      return this.levyCalculation.debtToEquity === null;
    }
  }
};
</script>
